import React from 'react';
import '../../StylesCSS/ButtonsLayout.css';
import '../../StylesCSS/PageLayout2.css';
import { School, Home, Input, Language, ArrowBack } from '@mui/icons-material'; // Import des icônes
import { useNavigate } from 'react-router-dom'; // Import de useNavigate

const PageLayout2 = () => {
    const navigate = useNavigate(); // Initialisation de useNavigate

    const handleSectionChange = (route) => {
        navigate(`/${route}`); // Navigation vers la route correspondante
    };

    return (
        <div className="page-layout2-shell" dir="rtl">
        <div className="page-layout2-content" style={{ maxWidth: '600px', margin: 'auto', textAlign: 'center' }}> {/* Centre le contenu */}
        <br></br>
                <div
                    className="page-layout2-hero"
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#B8B8B8",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#218C91",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للتالثة اعدادي</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#218C91",
              borderRadius: "2px",
            }}
          ></div>
        </div>
        <br></br>
                        <div className="page-layout2-heading">
                            <span>تهيئة المعطيات</span>
                            <h2>تدبير مجالس الأقســــام</h2>
                            <p>اختر المعطى الذي تريد تهيئته قبل متابعة العمل.</p>
                        </div>
                        <div className="buttons-container page-layout2-buttons" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}> {/* Conteneur centré */}
                {/* Button: المؤسسة الأصلية */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('OriginalInstitution')}
                    style={{
                        backgroundColor: '#33B5E6', // Couleur spécifique
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%', // Largeur des boutons pour uniformité
                        maxWidth: '400px', // Limite la taille des boutons
                    }}
                >
                    <School style={{ marginRight: '8px' }} /> {/* Icône */}
                    المؤسسة الأصلية
                </button>

                {/* Button: مؤسسة الاستقبال */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('EtablissementAccueil')}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Home style={{ marginRight: '8px' }} />
                    مؤسسة الاستقبال
                </button>

                {/* Button: ادخال العتبة */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('LeSeuil')}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Input style={{ marginRight: '8px' }} />
                    ادخال العتبة
                </button>

                {/* Button: ادخال الملاحظات */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('InputNotes')}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Input style={{ marginRight: '8px' }} />
                    ادخال الملاحظات
                </button>

                {/* Button: ادخال اللغة الاجنبية الثانية */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('DeuxiemeLangueSelonDepartement')}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Language style={{ marginRight: '8px' }} />
                    ادخال اللغة الاجنبية الثانية حسب القسم
                </button>

                {/* Button: Retour */}
                <button
                    className="btn btn-left"
                    style={{
                        backgroundColor: '#FF6347', // Couleur spécifique pour le bouton retour
                        color: 'white',
                        padding: '10px 20px',
                        margin: '20px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                    onClick={() => handleSectionChange('PageLayout')}
                >
                    <ArrowBack style={{ marginRight: '8px' }} />
                    Retour
                </button>
            </div>
        </div>
        </div>
    );
};

export default PageLayout2;
